(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-sm-announce]').forEach(function (bar) {
    if (bar.dataset.smBound) return;
    bar.dataset.smBound = '1';

    var key = bar.dataset.storageKey;
    try {
      if (key && sessionStorage.getItem(key) === '1') { bar.hidden = true; return; }
    } catch (e) {}

    var dismiss = bar.querySelector('[data-sm-announce-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        bar.hidden = true;
        try { if (key) sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-aspire-cta"]) return;
  try {
    
(function () {
  var root = document.getElementById('sm-aspire');
  if (!root) return;
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function initAddToCart() {
    qa('[data-add-to-cart]', root).forEach(function (btn) {
      if (btn.dataset.cartBound) return;
      btn.dataset.cartBound = '1';
      btn.addEventListener('click', function (ev) {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        ev.preventDefault();
        var originalText = btn.textContent;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) { document.dispatchEvent(new CustomEvent('sm:cart:updated', { detail: cart })); })
          .catch(function () { btn.textContent = 'Could not add — try again'; setTimeout(function () { btn.textContent = originalText; }, 2000); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddToCart);
  } else {
    initAddToCart();
  }
  document.addEventListener('shopify:section:load', initAddToCart);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-contact-help"] && !Shopify.designMode) return;
  try {
    
(function () {
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function initAccordion() {
    qa('.sm-contacthelp [data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('.sm-contacthelp__qbtn');
      if (!btn || btn.dataset.helpBound) return;
      btn.dataset.helpBound = '1';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
  document.addEventListener('shopify:section:load', initAccordion);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('faq');
  if (!root) return;
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function initAccordion() {
    qa('[data-faq-item]', root).forEach(function (item) {
      var btn = item.querySelector('.sm-faq__qbtn');
      if (!btn || btn.dataset.faqBound) return;
      btn.dataset.faqBound = '1';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
  document.addEventListener('shopify:section:load', initAccordion);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('sm-pdp-videos');
  if (!root) return;
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function pauseAll() {
    qa('[data-video-player] video', root).forEach(function (v) { v.pause(); });
    qa('[data-video-player]', root).forEach(function (p) { p.hidden = true; });
    qa('[data-video-trigger]', root).forEach(function (b) { if (!b.disabled) b.hidden = false; });
  }

  qa('[data-video-trigger]', root).forEach(function (btn) {
    if (btn.disabled || btn.dataset.videoBound) return;
    btn.dataset.videoBound = '1';
    btn.addEventListener('click', function () {
      var item = btn.closest('.sm-pdpvid__item');
      var player = item ? item.querySelector('[data-video-player]') : null;
      if (!player) return;
      pauseAll();
      player.hidden = false;
      btn.hidden = true;
      var video = player.querySelector('video');
      if (video) video.play();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pledge-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function initVideos() {
    qa('.sm-pledgestory [data-video-trigger]').forEach(function (btn) {
      if (btn.disabled || btn.dataset.videoBound) return;
      btn.dataset.videoBound = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.sm-pledgestory__videowrap, .sm-pledgestory__media');
        var player = wrap ? wrap.querySelector('[data-video-player]') : null;
        if (!player) return;
        player.hidden = false;
        btn.hidden = true;
        var video = player.querySelector('video');
        if (video) video.play();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideos);
  } else {
    initVideos();
  }
  document.addEventListener('shopify:section:load', initVideos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-shop-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid = document.querySelector('[data-shop-grid]');
  if (!grid) return;
  var qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var chipsHost = document.querySelector('[data-shop-chips]');
  var sortSelect = document.querySelector('[data-shop-sort]');
  var countEl = document.querySelector('[data-shop-count]');
  var emptyEl = document.querySelector('[data-shop-empty]');
  var bundleSpecial = grid.querySelector('[data-bundle-special]');

  var state = { filter: 'all', sort: 'featured' };

  function cards() {
    return qa('[data-shop-card]:not([data-bundle-special])', grid);
  }

  function applyState() {
    var showSpecial = bundleSpecial && (state.filter === 'all' || state.filter === 'bundle') && state.sort === 'featured';
    if (bundleSpecial) bundleSpecial.hidden = !showSpecial;

    var list = cards();
    var visible = 0;
    list.forEach(function (card) {
      var cats = (card.dataset.cat || '').split(',').filter(Boolean);
      var matchesFilter = state.filter === 'all' || cats.indexOf(state.filter) !== -1;
      var hideAsBundleDup = card.hasAttribute('data-bundle-dup') && showSpecial;
      card.hidden = !matchesFilter || hideAsBundleDup;
      if (!card.hidden) visible += 1;
    });
    if (showSpecial) visible += 1;

    var sorted = list.slice().sort(function (a, b) {
      if (state.sort === 'low') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
      if (state.sort === 'high') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
      if (state.sort === 'rated') return parseFloat(b.dataset.rating) - parseFloat(a.dataset.rating);
      if (state.sort === 'new') return parseFloat(b.dataset.added) - parseFloat(a.dataset.added);
      return parseFloat(a.dataset.order) - parseFloat(b.dataset.order);
    });
    sorted.forEach(function (card) { grid.appendChild(card); });
    if (bundleSpecial) grid.insertBefore(bundleSpecial, grid.firstChild);

    if (countEl) countEl.textContent = visible + (visible === 1 ? ' item' : ' items');
    if (emptyEl) emptyEl.hidden = visible !== 0;
  }

  if (chipsHost) {
    qa('.sm-chip', chipsHost).forEach(function (chip) {
      chip.addEventListener('click', function () {
        qa('.sm-chip', chipsHost).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        state.filter = chip.dataset.filter;
        applyState();
      });
    });
  }
  if (sortSelect) {
    sortSelect.addEventListener('change', function (e) {
      state.sort = e.target.value;
      applyState();
    });
  }

  function init() {
    applyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
